import { motion } from "framer-motion";
import { Monitor, Globe, RefreshCw, ShieldCheck } from "lucide-react";

const benefits = [
  {
    icon: Monitor,
    gradient: "bg-rinqel-blue-gradient",
    title: "Je computers? Als nieuw!",
    text: "Tijdens de overstap krijgen je bestaande computers een schone herinstallatie met de nieuwste versie van het besturingssysteem. Het voelt letterlijk als een nieuwe computer. Beter voor het milieu én je portemonnee — want ze gaan er zo weer jaren mee.",
  },
  {
    icon: Globe,
    gradient: "bg-rinqel-green-gradient",
    title: "Jouw domeinnaam, onze zorg",
    text: "Je domeinnaam (denk aan jouwbedrijf.nl) heeft achter de schermen instellingen nodig. Dat heet DNS — zie het als het telefoonboek van het internet. Een webbouwer gebruikt er maar één of twee, maar bij Microsoft 365 moeten er regelmatig dingen worden aangepast. Daarom nemen wij het beheer het liefst over. Jij blijft altijd eigenaar, wij draaien aan de knoppen.",
  },
  {
    icon: RefreshCw,
    gradient: "bg-hero-gradient",
    title: "Dag van de overstap? Gewoon doorwerken",
    text: "Omdat alles vooraf klaarstaat, kan je team op de dag van de overstap gewoon doorwerken. We wisselen computers door: je geeft je oude af en krijgt een vers ingerichte terug. Inloggen en klaar. Bij nieuwe hardware? Die staat al klaar — we helpen met de eerste keer inloggen.",
  },
  {
    icon: ShieldCheck,
    gradient: "bg-hero-gradient",
    title: "Continu veilig en up-to-date",
    text: "Na de overstap blijven we je Microsoft-omgeving bewaken met speciale software. We zorgen dat alles voldoet aan de laatste beveiligingsstandaarden — zonder dat jij er omkijken naar hebt. Zorgvuldig en gefaseerd, zodat je er geen last van hebt.",
  },
];

const MigrationBenefits = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-2xl font-bold md:text-3xl">
            Waarom onze klanten{" "}
            <span className="text-gradient">zo blij zijn</span>
          </h2>
          <p className="mt-3 text-lg text-muted-foreground">
            Geen stress, geen dataverlies, geen stilstand. Dat beloven we niet alleen — dat doen we.
          </p>
        </motion.div>

        <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-2">
          {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return (
              <motion.div
                key={benefit.title}
                className="rounded-xl border border-border bg-card p-6 shadow-card hover:shadow-card-hover transition-shadow"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
              >
                <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${benefit.gradient} text-primary-foreground mb-4`}>
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-semibold text-base">{benefit.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {benefit.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MigrationBenefits;
